/**
 * @ / # 命令检测工具
 *
 * 用于检测光标前是否输入了 @资产名 / /咒语 / #LoRA
 * 返回 { type, query, start } 或 null
 */

/**
 * 检测光标前的命令触发状态
 * @param {string} text - 完整文本
 * @param {number} cursorPos - 光标位置
 * @param {string[]} triggers - 要检测的触发符，默认 ['@', '/']（全屏框不支持 /）
 * @returns {{ type: string, query: string, start: number } | null}
 */
export function getCommandState(text, cursorPos, triggers = ['@', '/']) {
  const before = text.slice(0, cursorPos);

  const getMatch = (trigger, type) => {
    const index = before.lastIndexOf(trigger);
    if (index < 0) return null;

    const query = before.slice(index + 1);
    if (/\s/.test(query)) return null;

    if (trigger === '@' && query.includes('@')) return null;

    if (trigger === '/') {
      const prevChar = index === 0 ? '' : before[index - 1];
      if (prevChar && !/\s/.test(prevChar)) return null;
      if (query.includes('/')) return null;
    }

    if (trigger === '#' && query.includes('#')) return null;

    return { type, query, start: index };
  };

  const candidates = [];
  if (triggers.includes('@')) {
    const mention = getMatch('@', 'mention');
    if (mention) candidates.push(mention);
  }
  if (triggers.includes('/')) {
    const slash = getMatch('/', 'slash');
    if (slash) candidates.push(slash);
  }
  if (triggers.includes('#')) {
    const lora = getMatch('#', 'lora');
    if (lora) candidates.push(lora);
  }

  // 返回离光标最近的一个
  if (candidates.length === 0) return null;
  return candidates.reduce((a, b) => a.start > b.start ? a : b);
}
